import type { ISpread } from "../../spreadsSlice";

export const situationDevelopmentSpread: ISpread = {
  id: "spread_situation_development",
  name: "Ситуация и развитие",
  purpose:
    "Расширенный анализ текущей ситуации, влияний, возможностей, препятствий и потенциала дальнейшего развития.",
  cardsCount: 5,
  layout: "[1] [2] [3] [4] [5]",
  positions: [
    {
      id: "situation",
      title: "Ситуация",
      meaning: "Текущее положение и суть происходящего.",
    },
    {
      id: "influences",
      title: "Влияния",
      meaning: "Силы и обстоятельства, действующие прямо сейчас.",
    },
    {
      id: "opportunities",
      title: "Возможности",
      meaning: "То, что можно использовать или предпринять.",
    },
    {
      id: "obstacles",
      title: "Препятствия",
      meaning: "То, что мешает или ограничивает развитие.",
    },
    {
      id: "potential",
      title: "Потенциал",
      meaning: "Вероятное направление развития и скрытые перспективы.",
    },
  ],
  symbolism:
    "Переход от анализа текущей ситуации к обнаружению доступных возможностей, препятствий и дальнейшего потенциала.",
  archetypes: ["Рост", "Возможность", "Путь развития"],
  psychology:
    "Помогает увидеть не только текущее положение, но и доступные действия, внутренние ограничения и перспективы развития.",
  procedure: {
    preparation:
      "Сконцентрироваться на вопросе о текущей ситуации и возможностях её развития.",
    steps:
      "Перетасовать колоду; выложить пять карт по порядку; сначала рассмотреть ситуацию и влияния, затем возможности и препятствия, после этого — общий потенциал.",
  },
  interpretations: [
    "Потенциал показывает возможность дальнейшего развития, но требует реализации через доступные ресурсы и действия.",
    "Влияния могут одновременно содержать как поддержку, так и ограничение.",
  ],
  nuances: [
    "Это CUSTOM-расклад проекта, отдельный от SOURCE-расклада «Ситуация и её потенциал».",
    "Потенциал не является гарантированным результатом.",
  ],
  examples: [
    {
      cards: [
        "Императрица",
        "3 Жезлов",
        "Туз Пентаклей",
        "5 Кубков",
        "Колесо Фортуны",
      ],
      interpretation:
        "Ситуация содержит потенциал роста и расширения, доступна новая практическая возможность, однако развитию мешает фиксация на прошлых потерях.",
    },
  ],
  selfQuestions: [
    "Что я могу сделать, чтобы реализовать потенциал?",
    "Какие возможности доступны уже сейчас?",
    "Какие препятствия зависят от меня?",
  ],
};

